import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const NorthKoreaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15323'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15323)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 2.8H20V0H0V2.8Z'
					fill='#1461B6'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V11.2H0V14Z'
					fill='#1461B6'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 11.2H20V2.80005H0V11.2Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 10.2666H20V3.73328H0V10.2666Z'
					fill='#F53846'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.52362 6.99996C9.52362 8.28862 8.45763 9.33329 7.14267 9.33329C5.82771 9.33329 4.76172 8.28862 4.76172 6.99996C4.76172 5.71129 5.82771 4.66663 7.14267 4.66663L6.58109 6.24247L4.87825 6.27892L6.23402 7.28929L5.74318 8.88767L7.14267 7.93626L8.54216 8.88767L8.05132 7.28929L9.40709 6.27892L7.70425 6.24247L7.14267 4.66663C8.45763 4.66663 9.52362 5.71129 9.52362 6.99996Z'
					fill='white'
				/>
			</g>
		</svg>
	);
};

export default NorthKoreaFlagIcon;
